import { Helmet } from "react-helmet";
import React, { Component } from "react";
import "../../styles/depots/depots.scss";
import { Button } from "react-bootstrap";
import ZoneTable from "./zoneTable";
import axios from "axios";
import { encodeQueryData, apiHost } from "../../api/apiClient";
import { Link } from "react-router-dom";
import Layout from "../../Layout/layout";
import { setLoadingPage, setErrorMessage } from "../../reducers/actions";
import { connect } from "react-redux";
import queryString from "query-string";
import { downloadCSVFile } from "../../api/apiClient";

class Zones extends Component {
    constructor(props) {
        super(props);
        this.state = {
            depotList: [],
        };
    }
    async componentDidMount() {
        this.props.setLoadingPageAction(true);

        const values = queryString.parse(this.props.location.search);
        console.log("customerID", values.customerId);
        var urlAll = "";
        if (values.customerId) {
            this.customerId = values.customerId;
            let query = encodeQueryData(this.setCustomersQueryObject());
            urlAll = `${apiHost}/api/POI/GetAllPOIs?${query}`;
            this.getZones(urlAll);
        } else {
            let query = encodeQueryData(this.setCustomersQueryObject());
            urlAll = `${apiHost}/api/POI/GetAllPOIs?${query}`;
            this.getZones(urlAll);
        }
    }

    setCustomersQueryObject = () => {
        let data = {};
        data.SearchString = this.searchText;
        data.customerId = this.customerId;
        data.PageSize = this.pageSize;
        data.PageNumber = this.pageKey;
        data.SortDirection = this.sortDirection;
        data.SortString = this.sortString;
        return data;
    };

    getZones = async (url) => {
        try {
            const response = await axios.get(url, {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("token"),
                },
            });
            console.log("deootList", response.data);

            this.setState({ depotList: response.data });
            this.props.setLoadingPageAction(false);
        } catch (e) {
            if (e.response.status == "401") {
                this.props.history.push("/login");
            } else {
                this.props.setErrorMessageAction(`${e}`);
            }
            this.props.setLoadingPageAction(false);

            console.log(`😱 Axios request failed: ${e}`);
        }
    };

    downloadTemplate = (e) => {
        const csvTemplate = [{
            Name: "text",
            Description: "text",
            Address: "text",
            Duration: "number",
            Status: "text (Active/Disable)"
        }];
        downloadCSVFile(csvTemplate, "poi", "csv","template","");
    };

    render() {
        const { depotList } = this.state;
        const values = queryString.parse(this.props.location.search);
        return (
            <React.Fragment>
                <Layout>
                    <Helmet>
                        <title>All Points Of Interest </title>
                    </Helmet>
                    <div className="contentBody">
                        <div className="contentWrapper">
                            <h2>
                                All Points Of Interest
                                {values.customerId && (
                                    <small>
                                        {`filtered by customerName `}
                                        <a
                                            onClick={() => localStorage.removeItem("customer")}
                                            href="/zones"
                                        >
                                            <span>
                                                <i className=" fa fa-times"></i>
                                                {values.customerName}
                                            </span>
                                        </a>
                                    </small>
                                )}
                            </h2>
                            <div className="buttonContainer">
                                <Link to="/createZone">
                                    <Button variant="primary">Create new</Button>
                                </Link>
                                <Link to="/uploadCsv" className="uploadCsv">
                                    <Button variant="primary">Import CSV</Button>
                                </Link>
                                <Button variant="primary" style={{ marginLeft: "10px" }} onClick={(e) => this.downloadTemplate(e)}>Download Template</Button>
                            </div>

                            <div className="customers">
                                <ZoneTable depots={depotList} />
                            </div>
                        </div>
                    </div>
                </Layout>
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => ({
    loading: state.loading,
});
const mapDispatchToProps = {
    setLoadingPageAction: setLoadingPage,
    setErrorMessageAction: setErrorMessage,
};

export default connect(mapStateToProps, mapDispatchToProps)(Zones);
